import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Loader from "./components/Loader";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Login from "./components/login/login";
import Signup from "./components/signup/signup";
import Profile from "./pages/profile/ProfilePage";
import ProtectedRoute from "./components/ProtectedRoute";
import Aboutus from "./pages/AboutUs/aboutus";
import ContactUS from "./pages/ContactUs/contactus";
import Buyer from "./pages/Buyer/buyer";
import PropertyDetail from "./pages/PropertyDetails/propertydetails";
import AddProperty from "./components/addpropertydetails/addpropertydetails";
import TearmAndConditation from "./pages/tearm&conditions/tearm&conditions";
import PrivacyPolicy from "./pages/privacypolicy/privacypolicy";
import Disclaimer from "./pages/Disclaimer/Disclaimer";
import Support from "./pages/support/support";
import PlaceBid from "./pages/PlaceBid/PlaceBid";
import Purchagerequest from "./components/purchangerequest/purchangerequest";
import Purchageprofile from "./components/Purchageprofile/Purchageprofile";


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PaymentSuccess from "./components/PaymentSuccess/PaymentSuccess";
import DeleteAccountByEmail from "./pages/AccountDelete/accountDelete";
import Mylistingview from "./pages/MylistingView/mylistingview";
import Purchagdetails from "./pages/PurchageDetails/purchagedetails";
import BookTours from "./pages/BookTour/booktour";
import AuthCallback from "././components/login/AuthCallback";
import Shawnahuja from "./pages/Shawnahuja/Shawn_ahuja";
import Addpropertybymls from "./pages/AddpropertyByMls/AddpropertyByMls";
import MyListings from "./pages/Mylistings/mylistings";
import EditProperty from "./pages/Editproperty/editproperty"
// ... other imports ...

function AppContent() {
  const location = useLocation(); //Safe: inside Router
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // show loader 1s on each route change

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div>
      {loading && <Loader />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/home" element={<Home />} />

        <Route
          path="/Profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />

        <Route path="/aboutus" element={<Aboutus />} />

        <Route path="/contactus" element={<ContactUS />} />

        <Route path="/buyer" element={<Buyer />} />

        <Route path="/propertyDetail" element={<PropertyDetail />} />

        <Route path="/addproperty" element={<AddProperty />} />
        <Route path="/termsandconditions" element={<TearmAndConditation />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/support" element={<Support />} />
        <Route path="/placebid" element={<PlaceBid />} />
        <Route path="/purchagerequest" element={<Purchagerequest />} />
        <Route path="/purchageprofile" element={<Purchageprofile />} />
        <Route path="/accountDelete" element={<DeleteAccountByEmail />} />
        <Route path="/mylistingview" element={<Mylistingview />} />
        <Route path="/purchagdetails" element={<Purchagdetails />} />
        <Route path="/booktours" element={<BookTours />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/shawn-ahuja" element={<Shawnahuja />} />
        <Route path="/addpropertybymls" element={<Addpropertybymls />} />
        <Route path="/myListings" element={<MyListings />} />
        <Route path="/editProperty" element={<EditProperty />} />

        {/* Other routes */}
        <Route path="/payment-success" element={<PaymentSuccess />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
